import "../assets/NcAppNavigationToggle-upUgYNtL.css";
import l from "../Components/NcButton.mjs";
import { r as s, x as o, a as r } from "./_l10n-gZppkly8.mjs";
import { n as i } from "./_plugin-vue2_normalizer-u6G_3nkj.mjs";
s(o);
const c = {
  name: "MenuIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var p = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon menu-icon", attrs: { "aria-hidden": !t.title, "aria-label": t.title, role: "img" }, on: { click: function(n) {
    return t.$emit("click", n);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, _ = [], u = /* @__PURE__ */ i(
  c,
  p,
  _,
  !1,
  null,
  null,
  null,
  null
);
const m = u.exports, f = {
  name: "MenuOpenIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var g = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon menu-open-icon", attrs: { "aria-hidden": !t.title, "aria-label": t.title, role: "img" }, on: { click: function(n) {
    return t.$emit("click", n);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M21,15.61L19.59,17L14.58,12L19.59,7L21,8.39L17.44,12L21,15.61M3,6H16V8H3V6M3,13V11H13V13H3M3,18V16H16V18H3Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, d = [], v = /* @__PURE__ */ i(
  f,
  g,
  d,
  !1,
  null,
  null,
  null,
  null
);
const h = v.exports, C = {
  name: "NcAppNavigationToggle",
  components: {
    NcButton: l,
    MenuIcon: m,
    MenuOpenIcon: h
  },
  props: {
    open: {
      type: Boolean,
      required: !0
    }
  },
  emits: ["update:open"],
  computed: {
    label() {
      return this.open ? r("Close navigation") : r("Open navigation");
    }
  },
  methods: {
    toggleNavigation() {
      this.$emit("update:open", !this.open);
    }
  }
};
var M = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "app-navigation-toggle-wrapper" }, [e("NcButton", { staticClass: "app-navigation-toggle", attrs: { type: "tertiary", "aria-expanded": t.open ? "true" : "false", "aria-label": t.label, title: t.label, "aria-controls": "app-navigation-vue" }, on: { click: t.toggleNavigation }, scopedSlots: t._u([{ key: "icon", fn: function() {
    return [t.open ? e("MenuOpenIcon", { attrs: { size: 20 } }) : e("MenuIcon", { attrs: { size: 20 } })];
  }, proxy: !0 }]) })], 1);
}, $ = [], H = /* @__PURE__ */ i(
  C,
  M,
  $,
  !1,
  null,
  "71aea515",
  null,
  null
);
const x = H.exports;
export {
  x as N
};
